import React from "react"
import { graphql } from "gatsby"
import { Helmet } from "react-helmet"

import Layout from "components/Layout"
import Seo from "components/Seo"
import PageHeader from "components/PageHeader"

import { PostContent } from "page_components/blog"

const Post = ({ data, pageContext, location }) => {
  const servicesCategoriesData = data.allWpCategory.nodes.filter(
    service => service.services.nodes.length > 0
  )

  let fullSchema = JSON.parse(pageContext?.data?.seo?.schema?.raw)
  fullSchema["@graph"][0]["@id"] = fullSchema
    ? `${data.allSite.nodes[0].siteMetadata.siteUrl}/blog${fullSchema["@graph"][0]["@id"]}`
    : undefined

  return (
    <Layout location={location} services={servicesCategoriesData}>
      <PageHeader title="Blog" />
      <PostContent data={pageContext?.data} />

      {fullSchema && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(fullSchema)}
          </script>
        </Helmet>
      )}
    </Layout>
  )
}

export const Head = ({ pageContext, location }) => (
  <Seo
    title={pageContext?.data?.seo?.title ?? pageContext?.data?.title}
    description={pageContext?.data?.seo.metaDesc}
    pathname={location.pathname}
  />
)

export const query = graphql`
  query ($language: WpLanguageCodeEnum) {
    allWpCategory(
      filter: { language: { code: { eq: $language } } }
      sort: { name: ASC }
    ) {
      nodes {
        name
        services {
          nodes {
            title
            slug
            acfServices {
              servicesOrder {
                home
                menu
              }
              aboutHero {
                icon {
                  sourceUrl
                }
              }
            }
          }
        }
        description
      }
    }

    allSite {
      nodes {
        siteMetadata {
          siteUrl
        }
      }
    }
  }
`

export default Post
